import { ApiProperty } from "@nestjs/swagger"
import { IsNotEmpty,  IsUUID } from "class-validator"

export class LessonProgramConceptDto {
  @ApiProperty({ type: 'string', description: 'Identifiant unique du concept' })
  @IsNotEmpty()
  @IsUUID('4')
  id?: string

  @ApiProperty({ type: 'string', description: 'Identifiant unique de la leçon' })
  @IsNotEmpty()
  @IsUUID('4')
  lessonId?: string

  @ApiProperty({ type: 'string', description: 'Code du concept' })
  @IsNotEmpty()
  @IsUUID('4')
  programConceptId!: string
}
